import { domain } from 'modules/data';

export function filterTaxCodesByAccountClass(taxCodes: domain.XeroTaxCode[], account?: domain.XeroAccount) {
    const accountClass = account?.accountClass;

    return accountClass ? taxCodes.filter((t) => t.applicableToAccountClasses.includes(accountClass)) : taxCodes;
}
